import { spacer4 } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { IconExclamationAltActive } from "../Icon/IconExclamationAltActive";
export var IconExclamationAltActiveForText = styled(IconExclamationAltActive).attrs({
  iconSize: 16
}).withConfig({
  displayName: "IconExclamationAltActiveForText",
  componentId: "sc-1qghvhz-0"
})(["block-size:1.25rem;margin-inline-end:", ";flex-shrink:0;"], spacer4);